import { useContext } from 'react';
import { TopBarStationContext } from './topBarStationTypes';

export const useTopBarStation = () => {
  const context = useContext(TopBarStationContext);
  if (context === undefined) {
    throw new Error('useTopBarStation must be used within a TopBarStationProvider');
  }
  return context;
};
